export default "__VITE_ASSET__BYvV4PXk__"